import * as d3 from "d3";
import { dism, nodeSize } from "../static/data";

// ================================== DATA =====================================

// แปลงข้อมูลจาก hierarchy node มาเป็น array และเอามาแต่ data เท่านั้น
const flattenOnlyData = async (data) => {
  let result = [];
  const recurse = async (node) => {
    result.push(node.data);
    if (node.children) await node.children.forEach(recurse);
  };
  await recurse(data);
  return result;
};

// แปลงข้อมูลจาก hierarchy node มาเป็น array
const flatten = (root) => {
  let n = [],
    i = 0;

  const recurse = (node) => {
    if (node.children) node.children.forEach(recurse);
    if (!node.id) node.id = ++i;
    n.push(node);
  };
  recurse(root);
  return n;
};

// แปลงข้อมูลจาก array ไปเป็น hierarchy node
const stratify = (data) =>
  d3
    .stratify()
    .id((d) => d.child)
    .parentId((d) => d.parent)(data);

// สร้างตำแหน่งให้ node สำหรับวาด tree
const tree = (data) =>
  d3
    .tree()
    .nodeSize([nodeSize.width * 1.5, nodeSize.height * 2])
    .separation((a, b) => (a.parent == b.parent ? 1 : 1.25))(data);

// หา node ที่ต้องการลบด้วย id data ต้องเป็น hierarchy
const findNodeAndDelete = async (data, id) => {
  let result = data;
  let nodeCouple = "";

  //   function สำหรับไล่ไปตาม node เผื่อหา node ที่่ต้องการลบและลบ node นั้น
  const recurse = async (node, del) => {
    const relationId = node.id.split("_relation_");
    if (!node.family_head) {
      if (del) node.del = true;
      if (
        node.id === id ||
        relationId.includes(id) ||
        (node.id === nodeCouple &&
          node.parent !== "root" &&
          node.data.no_parent)
      ) {
        node.del = true;
        if (relationId.length === 2) {
          if (relationId[0] === id) {
            nodeCouple = relationId[1];
          } else {
            nodeCouple = relationId[0];
          }
        }
      }
    }
    if (node.children) {
      await node.children.forEach((item) => {
        recurse(item, node.del);
      });

      node.children = await node.children.filter((item) => {
        return !item.del;
      });
    }
  };

  await recurse(result);

  result = await flattenOnlyData(result);

  return result;
};

// add node ที่อยู่ level เดียวกันเช่น คู่สมรส
const addSameLevelNode = async (
  treenode,
  relationnode,
  data,
  relation,
  relationWith
) => {
  const tempTree = JSON.parse(JSON.stringify(treenode));
  const tempRelation = JSON.parse(JSON.stringify(relationnode));
  const nonValidRelation = await tempRelation.find(
    (node) =>
      node.source.id === relationWith.child ||
      node.source.id === data._id ||
      node.target.id === data._id ||
      node.target.id === relationWith.child
  );

  if (nonValidRelation) {
    fireCantHaveMultipleMarrySwal();
    return;
  }
  const addindex = tempTree.findIndex((v) => v.child === relationWith.child);
  const node = {
    child: data._id,
    data: data,
    parent: relationWith.parent,
    no_parent: true,
    relationWithParent: relation,
    sex: data.sex,
  };
  const relation_line = {
    source: {
      id: relationWith.child,
    },
    target: {
      id: data._id,
    },
  };

  const relation_node = {
    child: `${relationWith.child}_relation_${data._id}`,
    parent: relationWith.parent,
    data: {
      source: relationWith.data,
      target: data,
    },
    no_parent: true,
    hidden: true,
    relation_node: true,
    relationWithParent: "",
  };

  tempTree.splice(addindex + 1, 0, relation_node);
  tempTree.splice(addindex + 2, 0, node);
  tempRelation.push(relation_line);
  return [tempTree, tempRelation];
};

//   เปลี่ยนแปลงข้อมูล (edit)
const changeRelationSameLevel = async (
  treenodeData,
  relationnodeData,
  changeRelationTo,
  changeThis
) => {
  let resultTreenode = JSON.parse(JSON.stringify(treenodeData));
  let resultRelationnode = JSON.parse(JSON.stringify(relationnodeData));
  let parent;
  // find parent
  await resultTreenode.forEach((item) => {
    if (item.child === changeThis.parent) parent = item;
  });
  // validate if already marry then return
  const nonValidRelation = await resultRelationnode.find(
    (node) =>
      node.source.id === parent.child ||
      node.source.id === changeThis.data._id ||
      node.target.id === changeThis.data._id ||
      node.target.id === parent.child
  );
  if (nonValidRelation) {
    fireCantHaveMultipleMarrySwal();
    return [resultTreenode, resultRelationnode];
  }
  // delete node and relation
  resultTreenode = await findNodeAndDelete(
    await stratify(resultTreenode),
    changeThis.child
  );
  resultRelationnode = await findAndDeleteRelation(
    resultTreenode,
    resultRelationnode,
    changeThis.child
  );
  // add new node
  [resultTreenode, resultRelationnode] = await addSameLevelNode(
    resultTreenode,
    resultRelationnode,
    changeThis.data,
    changeRelationTo,
    parent
  );
  return [resultTreenode, resultRelationnode];
};

//   หา relation แล้วลบออก
const findAndDeleteRelation = async (treenode, relationNode, id) => {
  const result = relationNode;
  return await result.filter((item) => {
    const deleteRelationNotHaveNode = treenode.find(
      (obj) => obj.child === item.target.id || obj.child === item.source.id
    );
    return (
      item.source.id !== id &&
      item.target.id !== id &&
      deleteRelationNotHaveNode
    );
  });
};

//   add node ที่อยู่ด้านล่าง (ลูก node)
const addChildNode = (treenode, data, relation, parent) => {
  const temp = treenode;
  // const addindex = treeDataComputed.value.findIndex(
  //   (v) => v.child === selecting.value.data.child
  // );
  const node = {
    child: data._id,
    data: data,
    parent: parent,
    relationWithParent: relation,
    sex: data.sex,
  };
  // treeDataComputed.value.splice(addindex + 1, 0, test);
  // treeCurrentData.value.unshift(node);
  temp.unshift(node);
  return temp;
};

//   เปลี่ยน relation ของ node ไปเป็น node ที่เป็นลูก เช่น บุตร หลาน ลุง
const changeRelationChild = async (
  treenodeData,
  relationnodeData,
  changeRelationTo,
  changeThis
) => {
  let resultTreenode = JSON.parse(JSON.stringify(treenodeData));
  let resultRelationnode = JSON.parse(JSON.stringify(relationnodeData));
  if (changeThis.relationWithParent !== "คู่สมรส") {
    await resultTreenode.forEach((item) => {
      if (item.child === changeThis.child) {
        item.relationWithParent = changeRelationTo;
      }
    });
  } else {
    let parent;
    await resultRelationnode.forEach((item) => {
      if (item.source.id === changeThis.child) {
        parent = item.target.id;
      } else if (item.target.id === changeThis.child) {
        parent = item.source.id;
      }
    });
    resultTreenode = await findNodeAndDelete(
      await stratify(resultTreenode),
      changeThis.child
    );
    resultRelationnode = await findAndDeleteRelation(
      resultTreenode,
      resultRelationnode,
      changeThis.child
    );
    resultTreenode = await addChildNode(
      resultTreenode,
      changeThis.data,
      changeRelationTo,
      parent
    );
  }
  return [resultTreenode, resultRelationnode];
};

//   add node ที่สูงกว่า (parent node) ยังไม่เปิดใช้
const addParentNode = (data, relation) => {
  let tempData = JSON.parse(JSON.stringify(treeDataComputed.value));
  const selectingParent = selecting.value.data.parent;
  const selectingIndex = tempData.findIndex(
    (node) => node.child === selecting.value.data.child
  );
  if (!tempData[selectingIndex].no_parent) {
    swalCustom.fire({
      icon: "warning",
      text: "ไม่สามารถเพิ่มผู้ปกครองให้คนที่มีผู้ปกครองแล้ว",
      html: `<div style="font-size:18px;"><b/>ไม่สามารถเพิ่มผู้ปกครองให้คนที่มีผู้ปกครองแล้ว</div>`,
      timer: 4000,
    });
    selecting.value = null;
    return;
  } else if (selectingParent === "root") {
    tempData[selectingIndex].no_parent = false;
    tempData[selectingIndex].relationWithParent = relation;
    // const parentNode = treeCurrentData.value.findIndex(
    //   (node) => node.child === selectingParent
    // );
    const changedParentData = changeAllParentNode(
      selectingParent,
      data,
      tempData
    );

    changedParentData.unshift({
      child: data._id,
      data: data,
      parent: selectingParent,
      no_parent: true,
      relationWithParent: "",
      sex: data.sex,
    });

    // treeCurrentData.value = changedParentData;
    treeDataComputed.value = changedParentData;
  } else {
    tempData[selectingIndex].no_parent = false;
    tempData[selectingIndex].relationWithParent = relation;
    tempData[selectingIndex].parent = data._id;

    const indexOfParentOfparent = tempData.findIndex(
      (node) => node.child === selectingParent
    );

    tempData.push({
      child: data._id,
      parent: tempData[indexOfParentOfparent].parent,
      data: data,
      no_parent: true,
      relationWithParent: "",
      sex: data.sex,
    });
    // treeCurrentData.value = tempData;
    treeDataComputed.value = tempData;
  }
};

// ================================== DRAW =====================================
// สร้าง svg
const createSVG = (treeId) => {
  d3.select(`#${treeId}`)
    .selectAll("svg")
    .remove();
  // add svg to dom
  const svg = d3
    .select(`#${treeId}`)
    .append("svg")
    .attr("height", "100%")
    .attr("width", "100%")
    .attr("viewBox", `0 0 ${dism.width} ${dism.height}`)
    .attr("preserveAspectRatio", "xMinYMin")
    .attr("class", "grab-cursor");

  const g = svg.append("g");

  return [svg, g];
};

// สำหรับสร้างเส้นแนวตั้ง
const createVerticalLine = (d) => {
  if (d.target.data.no_parent) return ``;
  return `M${d.source.x + nodeSize.width / 2},${d.source.y +
    nodeSize.height / 2} v${nodeSize.height} H${d.target.x +
    nodeSize.width / 2} V${d.target.y + nodeSize.height / 2}`;
};

// หาตำแหน่ง center ให้ node ที่สร้างขึ้น (ทั้ง zoom และ x,y)
const getCenterTransform = (node) => {
  const box = node.node().getBBox();
  let scale = Math.min(
    dism.width / (box.width * 1.75),
    dism.height / (box.height * 1.75)
  );
  scale = scale === Infinity ? 1 : scale;
  let transform = d3.zoomIdentity;
  // Center [0, 0].
  transform = transform.translate(dism.width / 2, dism.height / 2);
  // Apply scale.
  transform = transform.scale(scale);
  transform = transform.translate(
    -box.x - box.width / 2,
    -box.y - box.height / 2
  );
  return transform;
};

// สร้าง icon attr
const createIconAttr = (parentNode) => {
  return parentNode
    .append("svg")
    .attr("xmlns", "http://www.w3.org/2000/svg")
    .attr("width", "24px")
    .attr("height", "24px")
    .attr("viewBox", "0 0 24 24")
    .attr("fill", "none")
    .attr("stroke", "currentColor")
    .attr("stroke-width", 2)
    .attr("stroke-linecap", "round")
    .attr("stroke-linejoin", "round");
};

// วาด icon ถังขยะ
const createTrashIcon = (parentNode) => {
  const trashIcon = createIconAttr(parentNode).attr(
    "class",
    "feather feather-trash-2 inline-block mr-3"
  );
  trashIcon.append("polyline").attr("points", "3 6 5 6 21 6");
  trashIcon
    .append("path")
    .attr(
      "d",
      "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
    );
  trashIcon
    .append("line")
    .attr("x1", 10)
    .attr("y1", 11)
    .attr("x2", 10)
    .attr("y2", 17);
  trashIcon
    .append("line")
    .attr("x1", 14)
    .attr("y1", 11)
    .attr("x2", 14)
    .attr("y2", 17);
};

// วาด icon edit
const createEditIcon = (parentNode) => {
  const editIcon = createIconAttr(parentNode).attr(
    "class",
    "feather feather-edit-3 inline-block mr-3"
  );
  editIcon.append("path").attr("d", "M12 20h9");
  editIcon
    .append("path")
    .attr("d", "M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z");
};

// วาด icon บวกกลมๆ
const createPlusIcon = (parentNode) => {
  const plusIcon = createIconAttr(parentNode).attr(
    "class",
    "feather feather-plus-circle inline-block mr-3"
  );
  plusIcon
    .append("circle")
    .attr("cx", 12)
    .attr("cy", 12)
    .attr("r", 10);
  plusIcon
    .append("line")
    .attr("x1", 12)
    .attr("y1", 8)
    .attr("x2", 12)
    .attr("y2", 16);
  plusIcon
    .append("line")
    .attr("x1", 8)
    .attr("y1", 12)
    .attr("x2", 16)
    .attr("y2", 12);
};

const createRectMenuIcon = (node) => {
  node
    .append("rect")
    .attr("height", 25)
    .attr("width", 40)
    .attr("fill", "transparent");

  for (let i = 0; i < 3; i++) {
    node
      .append("circle")
      .attr("r", () => 4.5)
      .attr("transform", `translate(${6 + i * 12}, 12.5)`)
      .attr("fill", "white");
  }
};

const createRelationMenuIcon = (node) => {
  const relationIcon = node.append("g").attr("transform", `translate(22.5, 0)`);

  relationIcon.append("circle").attr("class", "relation-addnode");

  relationIcon
    .append("path")
    .attr("d", `M0,-6.25 V6.25 M-6.25,0 H6.25 `)
    .attr("fill", "none")
    .attr("stroke", "lightgray")
    .attr("stroke-width", 2)
    .attr("stroke-linecap", "round");
};

const createRectNode = (nodes, callbackFunction) => {
  const enterNodes = nodes
    .enter()
    .append("g")
    .attr("transform", (d) => `translate(${d.x}, ${d.y})`)
    .attr("class", (d) =>
      !d.data.hidden && !d.data.sex && d.data.child !== "root"
        ? "cursor-pointer"
        : undefined
    )
    .on("click", (evt, d) => {
      if (!d.data.hidden && !d.data.sex && d.data.child !== "root")
        callbackFunction(evt, d);
    });
  // .on("click", props.edit ? handleClickNode : null);

  enterNodes
    .filter((d) => d.data.hidden && !d.data.child.includes("root"))
    .append("rect")
    .attr("class", "hidden-node");

  enterNodes
    .filter((d) => !d.data.hidden && d.data.householdHead)
    .append("rect")
    .attr("transform", "translate(-22.5, -22.5)")
    .attr("class", "household-head");

  enterNodes
    .filter((d) => !d.data.hidden && d.data.family_head)
    .append("rect")
    .attr("transform", "translate(-10, -10)")
    .attr("class", "family-head");

  enterNodes
    .filter((d) => !d.data.hidden)
    .append("rect")
    .attr("class", (d) => {
      if (d.data.sex === "หญิง") return "tree-node women-node";
      if (d.data.sex === "ชาย") return "tree-node men-node";
      return "tree-node nosex-node";
    });
  enterNodes
    .filter((d) => !d.data.hidden && d.data.sex)
    .append("text")
    .text((d) => d.data.data.name)
    .attr("class", "node-text")
    .attr(
      "transform",
      (d) => `translate(${nodeSize.width / 2}, ${nodeSize.height / 2 + 10})`
    );

  enterNodes
    .filter((d) => !d.data.hidden && !d.data.sex)
    .append("text")
    .text((d) => d.data.data.title)
    .attr("class", "node-text")
    .attr("transform", (d) => {
      if (d.data.child === "root")
        return `translate(${nodeSize.width / 2}, ${nodeSize.height / 2 + 10})`;
      return `translate(${nodeSize.width / 2}, ${nodeSize.height / 2 - 10})`;
    });

  enterNodes
    .filter((d) => !d.data.hidden && !d.data.sex)
    .append("text")
    .text((d) => d.data.data.name)
    .attr("class", "node-text")
    .attr(
      "transform",
      (d) => `translate(${nodeSize.width / 2}, ${nodeSize.height / 2 + 30})`
    );
  return enterNodes;
};

export {
  createSVG,
  flattenOnlyData,
  flatten,
  stratify,
  tree,
  createVerticalLine,
  dism,
  nodeSize,
  getCenterTransform,
  createTrashIcon,
  createEditIcon,
  createPlusIcon,
  findNodeAndDelete,
  addSameLevelNode,
  changeRelationSameLevel,
  findAndDeleteRelation,
  addChildNode,
  changeRelationChild,
  createRectMenuIcon,
  createRelationMenuIcon,
  createRectNode,
};
